// extracted by mini-css-extract-plugin
module.exports = {"viewBlockWrapper":"DetailBlockView_viewBlockWrapper__1IPVV","content":"DetailBlockView_content__217k5","infoGroup":"DetailBlockView_infoGroup__2Tikb"};